import styled from "styled-components";

export const Container = styled.div`

    margin: 0 auto;
    width: 100vw;
    max-width: 1020px;
    padding: 0 20px;

`